import { useEffect, useState } from "react";
import { fmtDate } from "@/lib/status";
import { Search, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";

export function PatientPicker({ onPick, onAdd }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/patients", { params: { q } }).then((r) => setRows(r.data.items)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div>
      <div className="relative"><Search className="w-4 h-4 absolute left-3 top-3.5 text-slate-400" />
        <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, DOB, chart or EHR ID" className="pl-9 h-11" data-testid="patient-picker-search" /></div>
      <ul className="mt-2 max-h-72 overflow-y-auto divide-y border rounded-md" data-testid="patient-picker-results">
        {rows.map((p) => (
          <li key={p.id}><button className="w-full text-left px-3 py-2.5 hover:bg-slate-50 text-sm" onClick={() => onPick(p)} data-testid={`patient-pick-${p.id}`}>
            <b>{p.first_name} {p.last_name}</b> <span className="text-slate-500">DOB {fmtDate(p.dob) || "missing"} - {p.chart_id}</span>
            {p.identity_status !== "verified" && <span className="ml-2 text-xs text-amber-700">incomplete identity</span>}
          </button></li>
        ))}
        {rows.length === 0 && (
          <li className="p-4 text-center text-sm text-slate-500" data-testid="patient-picker-empty">No matching patient in this organization.
            {onAdd && <Button variant="outline" size="sm" className="mt-2 block mx-auto" onClick={onAdd} data-testid="patient-picker-add"><UserPlus className="w-4 h-4 mr-1 inline" />Add patient</Button>}
          </li>
        )}
      </ul>
    </div>
  );
}

export default function FindPatientDialog({ open, onOpenChange, onPick, onAdd }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="find-patient-dialog">
        <DialogHeader><DialogTitle>Open chart</DialogTitle></DialogHeader>
        {open && <PatientPicker onPick={onPick} onAdd={onAdd} />}
      </DialogContent>
    </Dialog>
  );
}
